import getOfficesMarkers from './getOfficesMarkers';

export const getMarkerStructure = (officeId, offices, undergrounds) => {
  const markersClassNames = {
    happy: 'markerHappy',
    indifferent: 'markerIndifferent',
    sad: 'markerSad',
    closed: 'markerGrey',
  };

  const neededOffice = offices.find(office => office.id === officeId);

  if (!officeId) return null;

  return getOfficesMarkers(markersClassNames, [neededOffice], undergrounds)[0];
};
